module.exports = __webpack_public_path__ + "static/media/2_euro_free_600_100.088758a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2_euro_free_600_100.jpg
// module id = 63
// module chunks = 0